import React from 'react';
import './OtherWorks.css';
import data from '../data.json';

const OtherWorks = () => {
    const works = data.otherWorks;

    return (
        <div className="other-works-container">
            <div className="other-works-title">Other works</div>
            <div className="other-works-description">Here are a collection of ten digital illustrations created using Adobe Photoshop and Adobe Illustrator when I was 15 years old. These flat design objects highlight my early passion for digital design and graphics. Since my youth, I've been fascinated by the world of visual aesthetics, which has fueled my journey and growth in the design field. This longstanding interest has naturally led me to pursue a career as a UX/UI Designer, where I can combine my love for visual design with creating intuitive and engaging user experiences. Additionally, I also specialize in web development. For instance, the very website you're navigating right now was developed by me.</div>
            <div className="other-works-items">
                {works.map(work => (
                    <div key={work.id} className="other-work-item">
                        <img src={work.image} alt={work.title} className="other-work-image" />
                        <p className="other-work-item-title">{work.title}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OtherWorks;